'use client';

import { type Editor } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react/menus';
import { useTiptapCommands } from '../hooks/useTiptapCommands';

type TiptapBubbleToolbarProps = {
  editor: Editor;
};

export const TiptapBubbleToolbar = ({ editor }: TiptapBubbleToolbarProps) => {
  const commands = useTiptapCommands(editor);

  return (
    <BubbleMenu
      editor={editor}
      shouldShow={({ editor: currentEditor, state }) => {
        const { from, to } = state.selection;
        const hasTextSelection = from !== to;
        if (!hasTextSelection) {
          return false;
        }

        if (currentEditor.isActive('codeBlock')) {
          return false;
        }
        if (currentEditor.isActive('image')) {
          return false;
        }

        return true;
      }}
    >
      <div className="flex items-center gap-0.5 rounded-lg border border-base-300 bg-base-100 p-1 shadow-lg">
        {commands.inline.items.map((item) => (
          <button
            key={item.label}
            type="button"
            className={`btn btn-xs ${item.isActive ? 'btn-primary' : 'btn-ghost'}`}
            title={item.title}
            aria-label={item.label}
            disabled={item.disabled}
            onClick={item.onClickAction}
          >
            {item.label}
          </button>
        ))}
      </div>
    </BubbleMenu>
  );
};
